// Returns the beat-label entries eligible for a keyboard shortcut:
// single-character slugs, excluding DEFAULT_LEFT_CLICK, deduplicated by lowercased slug.
export const getBeatShortcuts = (beatLabel) => {
    if (!Array.isArray(beatLabel)) return []
    const seen = new Set()
    const shortcuts = []
    for (const label of beatLabel) {
        if (!label || typeof label.slug !== 'string') continue
        if (label.name === 'DEFAULT_LEFT_CLICK') continue
        if (label.slug.length !== 1) continue
        const key = label.slug.toLowerCase()
        if (seen.has(key)) continue
        seen.add(key)
        shortcuts.push(label)
    }
    return shortcuts
}

export const hasBeatShortcut = (label) => {
    if (!label || typeof label.slug !== 'string') return false
    if (label.name === 'DEFAULT_LEFT_CLICK') return false
    return label.slug.length === 1
}
